<div class="p-fileupload p-fileupload-advanced p-component">
  <!-- header - only show if more than one file -->
  <div class="p-fileupload-header justify-end" *ngIf="existingFileHeader">
    <button pButton
      class="p-ripple p-button p-component p-button-icon-only p-button-danger p-button-rounded p-button-text p-fileupload-file-remove-button"
      type="button" pTooltip="Supprimer tous" severity="secondary" (click)="onAllRemoved()"
      [disabled]="fileList.length === 0 || disabled">
      <i class="pi pi-times"></i>
    </button>
  </div>
  <!-- content -->
  <div class="p-fileupload-content">
    <p-progressbar *ngIf="fileList === []"></p-progressbar>
    <div class="p-fileupload-file-list">
      <div class="p-fileupload-file" *ngFor="let file of fileList">
        <img src="" alt="" class="p-fileupload-file-thumbnail" />
        <div class="p-fileupload-file-info">
          <span tabindex="0" role="button" (click)="openFile(file)" (keydown)="openFile(file)"
            class="p-fileupload-file-name">{{ file?.filename }}.{{ file?.extension }}</span>
          <span class="p-fileupload-file-size">{{ file?.size }}</span>
        </div>
        <div class="p-fileupload-file-actions">
          <button type="button"
            class="p-ripple p-button p-component p-button-icon-only p-button-secondary p-button-rounded p-button-text p-fileupload-file-download-button"
            (click)="onFileDownLoad(file)" *ngIf="onFileDownLoad">
            <i class="pi pi-download"></i>
          </button>
          <button [disabled]="disabled" type="button"
            class="p-ripple p-button p-component p-button-icon-only p-button-danger p-button-rounded p-button-text p-fileupload-file-remove-button"
            (click)="onFileRepresentationChange(file)" *ngIf="onFileRepresentationChange">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>